import React, { useCallback, useRef, useState } from 'react'

import { useFiltro } from 'modules/pagamentos/hooks/useFiltro'
import Calendar from 'shared/components/Calendar'
import Text from 'shared/components/Text'
import { colors } from 'shared/styles/colors'
import ExportarExtratoPdf from '../ExportarExtratoPdf'
import {
  Container,
  ContainerCalendar,
  ContainerExportarExtratoPdf,
  ContainerFilter,
  ContainerTextCalendar,
  Label,
  ContainerButton,
} from './styles'
import { IExportarExtrato } from 'modules/pagamentos/domain/usecases/ExportarExtrato'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import Button from '../../../../../../../shared/components/Button'
import ModalSolicitacaoExtrato from '../ExtratoItem/ModalSolicitacaoExtrato'
import EExportarExtratoTipoMensagem from '../../../../../domain/entities/EExportarExtratoTipoMensagem'

import { differenceInDays } from 'date-fns'
import { useHistory } from 'react-router-dom'
import PagamentoRoutes from 'modules/pagamentos/utils/PagamentoRoutes'

interface FiltroExtratoProps {
  exportarExtrato: IExportarExtrato
}

const FiltroExtrato: React.FC<FiltroExtratoProps> = ({
  exportarExtrato,
}: FiltroExtratoProps) => {
  const {
    dateIni,
    dateFim,
    setDateIni,
    setDateFim,
    fetchExtrato,
    setLoading,
    setRequestError,
    extrato,
  } = useFiltro()
  const { frotistaId } = useFrotista()
  const history = useHistory()
  const componentRef = useRef()

  const [mostrarModalSolicitacaoExtrato, setMostrarModalSolicitacaoExtrato] =
    useState(false)
  const [sucessoSolicitacao, setSucessoSolicitacao] = useState(undefined)
  const [tipoMensagem, setTipoMensagem] = useState(null)

  const handleDateIniChange = useCallback(
    (date: Date) => {
      setDateIni(date)
    },
    [setDateIni],
  )

  const handleDateFimChange = useCallback(
    (date: Date) => {
      setDateFim(date)
    },
    [setDateFim],
  )

  const handleExportarExtrato = useCallback(async () => {
    const quantidadeDiasPermitido = 31

    if (
      Math.abs(differenceInDays(dateIni, dateFim)) > quantidadeDiasPermitido
    ) {
      setTipoMensagem(EExportarExtratoTipoMensagem.VALIDACAO_PERIODO)
      setSucessoSolicitacao(false)
      setMostrarModalSolicitacaoExtrato(true)
      return
    }

    setLoading(true)
    setRequestError('')

    try {
      const { sucesso } = await exportarExtrato.execute({
        data_inicio: dateIni,
        data_fim: dateFim,
        frotista_id: frotistaId,
      })

      setSucessoSolicitacao(sucesso)
      setTipoMensagem(
        sucesso
          ? EExportarExtratoTipoMensagem.SUCESSO
          : EExportarExtratoTipoMensagem.ERRO,
      )

      setMostrarModalSolicitacaoExtrato(true)
      return
    } catch (error) {
      if (error instanceof Error) {
        setRequestError(error.message)
      } else {
        setRequestError('Erro ao exportar extrato da conta')
      }
    } finally {
      setLoading(false)
    }
  }, [dateIni, dateFim, fetchExtrato])

  const handleComprovante = () => {
    history.push(PagamentoRoutes.COMPROVANTE)
  }

  return (
    <>
      <ModalSolicitacaoExtrato
        sucesso={sucessoSolicitacao}
        isOpened={mostrarModalSolicitacaoExtrato}
        closeModal={() => setMostrarModalSolicitacaoExtrato(false)}
        tipo={tipoMensagem}
      />
      <Container>
        <ContainerFilter>
          <ContainerTextCalendar>
            <Text style={{ margin: '8px 10px' }} color={colors.blue}>
              Período
            </Text>
            <ContainerCalendar>
              <Calendar
                selectedDate={dateIni}
                handleDateChange={handleDateIniChange}
                autoOk={true}
                inputReadOnly={true}
              />
              <Label>até</Label>
              <Calendar
                selectedDate={dateFim}
                handleDateChange={handleDateFimChange}
                autoOk={true}
                inputReadOnly={true}
              />
            </ContainerCalendar>
          </ContainerTextCalendar>
        </ContainerFilter>
        <ContainerButton>
          <Button
            color={colors.white}
            fontColor={colors.green}
            style={{ border: `1px solid ${colors.green}`, marginRight: '6px' }}
            size="large"
            name="Documentos"
            onClick={() => handleComprovante()}
          >
            Documentos
          </Button>
          <Button
            color={colors.green}
            size="large"
            name="Exportar Extrato"
            onClick={() => handleExportarExtrato()}
          >
            Exportar Extrato
          </Button>
        </ContainerButton>
        {extrato && (
          <ContainerExportarExtratoPdf>
            <div ref={componentRef}>
              <ExportarExtratoPdf
                dados={extrato}
                dataInicial={dateIni}
                dataFinal={dateFim}
              />
            </div>
          </ContainerExportarExtratoPdf>
        )}
      </Container>
    </>
  )
}

export default FiltroExtrato
